<template>
  <b-card class="job-referrals-list-item" body-class="p-4" footer-tag="footer">
    <b-row class="title">
      <b-col cols="12">
        <h3>
          {{ job.title }}
          <template v-if="job.department && job.department.name">in {{ job.department.name }}</template>
          <template v-if="recruiter.role !== 'SUPER_ADMIN'">from <a href="#" @click.prevent :id="recruiterPopoverID">{{ recruiter.fullName }}</a></template>
        </h3>
      </b-col>
    </b-row>

    <b-card-group deck>
      <b-card class="contact-details" body-class="text-center">
        <img :src="`/static/images/avatars/main${contact.avatar || 1}.png`" class="contact-picture mb-3"/>
        <div class="contact-name"><b><a class="card-link" href="#" @click.prevent v-b-modal="contactModalID">{{ contact.fullName }}</a></b></div>
        <div class="jobTitle grey" v-if="contact.latestEmployment">
          {{ contact.latestEmployment.title }} at <b>{{ contact.latestEmployment.companyName }}</b>
        </div>
        <b-card-body slot="footer">
          <a class="card-link" href="#" @click.prevent v-b-modal="contactModalID">View Profile</a>
        </b-card-body>
      </b-card>
      <div>
        <font-awesome-icon icon="exchange-alt" class="grey match-icon" />
      </div>
      <b-card class="job-details bg-primary-a1 text-center">
        <span class="black">
          <b><router-link class="card-link" :to="{ name: 'JobShow', params: { jobID } }">{{ job.title }}</router-link></b>
          <template v-if="job.department && job.department.name">in <b>{{ job.department.name }}</b></template>
        </span>
        <span class="small-font grey">on {{(new Date(parseInt(referral.updated, 10))).toLocaleDateString("en-GB", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }).toString()}}</span>
        <template v-if="job.referralBonus">
          <span class="small-font"><font-awesome-icon icon="money-bill-alt" />{{ job.referralBonus}} bonus</span>
        </template>
        <b-card-body slot="footer">
          <router-link class="card-link" :to="{ name: 'JobShow', params: { jobID } }" target="_blank">View role</router-link>
        </b-card-body>
      </b-card>
    </b-card-group>

    <b-popover class="recruiterDetails" v-if="recruiter" :target="recruiterPopoverID" triggers="hover focus">
      <template v-slot:title>{{ recruiter.fullName || 'Recruiter' }}</template>
      <template v-if="recruiter.title">
        <b>{{ recruiter.title }}</b><br/>
      </template>
      <template v-if="recruiter.emailAddress">
        <b>Email:</b> <a :href="`mailto:${recruiter.emailAddress}`">{{ recruiter.emailAddress }}</a><br/>
      </template>
      <template v-if="recruiter.phoneNumber">
        <b>Phone:</b> <a :href="`tel:${recruiter.phoneNumber}`">{{ recruiter.phoneNumber }}</a><br/>
      </template>
      <template v-if="referral.recruiterMessage">
        <b>Request:</b> <p class="recruiter-message">{{ referral.recruiterMessage }}</p>
      </template>
    </b-popover>

    <contact-modal v-if="contactID" :contact="contact" :id="contactModalID"/>
    <employee-respond-to-referral-request-modal v-if="referralID" :referralID="referralID"
      ref="referralReplyModal" :id="referralReplyModalID" @finished="$emit('finished')"/>

    <div slot="footer">
      <div class="request-buttons">
        <div class="request-button"  @click="() => openIntroductionModal('NO')">
          <div class="bg-primary-a2 round-icon" @click="() => openIntroductionModal('NO')">
            <font-awesome-icon icon="times" />
          </div>

          Won't Refer
        </div>
        <!-- <div class="request-button" @click="() => openIntroductionModal('NOT_SURE')">
        <div class="bg-primary-a2 round-icon" >
        <font-awesome-icon icon="question" />
      </div>

      I'm not sure
    </div> -->
    <div class="request-button primary-background-color" @click="() => openIntroductionModal('SHARE')">
      <div class="bg-primary-a2 round-icon" >
        <font-awesome-icon icon="check" />
      </div>

      Refer this candidate
    </div>
  </div>
</div>
</b-card>
</template>

<script>
import gql from 'graphql-tag';
import ContactModal from '@/modals/contact-profile';
import EmployeeRespondToReferralRequestModal from '@/modals/employee-respond-to-referral-request';
import ContactProfileFragment from '@/graphql/fragments/ContactProfile.gql';

export const JobReferralListItemFragment = gql`
${ContactProfileFragment}

fragment JobReferralListItem on JobReferral {
  id
  contact {
    ...ContactProfile
  }
  job {
    id
    title
    department {
      id
      name
    }
  }
  recruiter {
    id
    fullName
    emailAddress
    phoneNumber
    title
  }
  recruiterMessage
  shareCode
  updated(format:"DDDo MMMM YYYY HH:mm")
}
`;

export default {
  name: 'JobReferralListItem',
  props: {
    referral: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ContactModal,
    EmployeeRespondToReferralRequestModal,
  },
  mounted() {
    const { query, name } = this.$route;
    if (name === 'ReferralRequests' && query && query.referralID && query.action && query.referralID === this.referral.id) {
      if (query.action === 'refer') {
        this.openIntroductionModal('SHARE');
      }
      if (query.action === 'unsuitable') {
        this.openIntroductionModal('NO');
      }
    }
  },
  methods: {
    openIntroductionModal(state) {
      this.$refs.referralReplyModal.show(state);
    }
  },
  computed: {
    referralID() {
      const { id } = this.referral;
      return id;
    },
    contact() {
      const { contact } = this.referral;
      return contact && contact.id ? contact : null;
    },
    contactID() {
      const { contact } = this.referral;
      return contact && contact.id ? contact.id : null;
    },
    contactModalID() {
      const { contactID } = this;
      return `contact-modal-${contactID}`;
    },
    job() {
      const { job } = this.referral;
      return job && job.id ? job : null;
    },
    jobID() {
      const { job } = this.referral;
      return job && job.id ? job.id : null;
    },
    recruiter() {
      const { recruiter } = this.referral;
      return recruiter && recruiter.id ? recruiter : null;
    },
    recruiterID() {
      const { recruiter } = this.referral;
      return recruiter && recruiter.id ? recruiter.id : null;
    },
    recruiterPopoverID() {
      return `recruiter-info-${this._uid}-${this.recruiterID}`;
    },
    referralReplyModalID() {
      const { referralID } = this;
      return `employee-makes-introduction-modal-${referralID}`;
    },
  },
};
</script>

<style lang="scss">
.job-referrals-list-item {

  .match-icon {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
    margin: 0 auto;
    display: block;
    height: 2rem;
    width: 2rem;
  }
  .card-footer {
    position: relative;
    text-align: center;
    padding: 0;

    .request-buttons {
      border-top-style: none;
    }
  }

  .title {
    margin-bottom: 1rem;
  }
  .jobTitle {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
  }

  .card-deck {
    b a {
      color: #000;
      font-weight: bold;
    }

    .card-footer {
      background-color: transparent;

      a {
        font-weight: bold;
      }
    }
  }

  .details {
    color: #dadada;
    text-align: center;

    img {
      margin: 0 auto;
      display: block;
      margin-bottom: 1rem;
      height: 60px;
    }

    .contact-name {
      color: #313743;
    }
  }

  .job-details {
    & > .card-body {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .svg-inline--fa {
      margin-right: 3px;
      opacity: 0.9;
    }
  }

}

.popover.recruiterDetails {

  .recruiter-message {
    white-space: pre-wrap;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/job-referrals/list-item.vue